import React, { useEffect, useState } from 'react';

import { uniqBy } from 'lodash';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import theme from 'constants/theme';

import { getOrganizationFunctions } from 'services/admin';
import { showErrorSnackbar } from 'services/snackbar';

import { DropdownContainer, StyledDropdownListElement } from './CommonComponents';

const getAllGradesArray = ({ functions }) => {
  const allGrades = [];
  if (!functions) {
    return allGrades;
  }
  functions?.forEach(({ grades, childFunctions }) => {
    if (grades) {
      grades?.forEach(({ grade }) => allGrades.push(grade));
    }
    if (childFunctions) {
      allGrades.push(getAllGradesArray({ functions: childFunctions }));
    }
  });
  return allGrades;
};

const uniqueGradesArray = (array = []) => {
  const flattenedArray = array?.flat(Infinity);
  return uniqBy(flattenedArray, 'uuid');
};

const CohortCreationGrade = ({ selectedValues = {}, setSelectedGrade }) => {
  // functions and levels
  const dispatch = useDispatch();
  const [functions, setFunctions] = useState(null);
  const [loadingFunctions, setLoadingFunctions] = useState(true);

  const grades = uniqueGradesArray(getAllGradesArray({ functions: functions ?? [] }));

  const fetchData = () => {
    setLoadingFunctions(true);
    getOrganizationFunctions()
      .then((res) => {
        setFunctions(res);
      })
      .catch((err) => {
        console.error('Error in fetching functions : ', err);
        dispatch(showErrorSnackbar(err.message));
      })
      .finally(() => {
        setLoadingFunctions(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  // end of functions and levels

  return (
    <>
      {grades?.map(({ uuid, name }) => {
        const isSelected = Boolean(selectedValues[uuid]);
        return (
          <DropdownContainer>
            <OptionWrapper
              onClick={() => {
                setSelectedGrade({ uuid, name });
              }}
            >
              <StyledDropdownListElement
                checked={isSelected}
                radioColor={theme.palette.icons.blue}
                hoverColor={theme.palette.icons.blue}
                label={name}
              />
            </OptionWrapper>
          </DropdownContainer>
        );
      })}
    </>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export { CohortCreationGrade };
